import { Vue, Component } from 'vue-property-decorator'
import APP_CONST from '@/constants/AppConst'
import applicationStore from '@/store/modules/applications/applicationStore'
import formsStore from '@/store/modules/forms/formsStore'
import APP_UTILITIES from '@/utilities/commonFunctions'

@Component
export default class ActivePrograms extends Vue {
  public tooltipText: string = ''
  public tooltipIndex: number = -1
  public styleObj = {}

  get programList() {
    return applicationStore.activeProgramWithScholarCount
  }

  get enrolledApplications() {
    return applicationStore.allEnrolledApplications
  }

  get submittedScholars() {
    return applicationStore.submittedScholars
  }

  completeItems(programId: number) {
    formsStore.resetApplication()
    formsStore.updateScholarData({})
    formsStore.saveGuardianDetails({
      email: '',
      firstName: '',
      lastName: '',
      birthdate: '',
      relation: '',
      primaryGaurdian: '',
      phone: '',
      phonetype: '',
      secondaryPhone: '',
      secondaryPhoneType: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zipCode: '',
      homeLanguage: ''
    })
    formsStore.resetEmergencyFields()
    formsStore.mutateCurrentPart(APP_CONST.ONE)
    let applicationSubmissions: any = this.enrolledApplications.filter((el: any) => {
      return (
        el.programId == programId &&
        el.status == APP_CONST.APPLICATION_PUBLISHED_STATUS &&
        !el.isCompleted
      )
    })
    applicationSubmissions = applicationSubmissions.sort(function (a: any, b: any) {
      if (a.scholarFirstName.toLowerCase() < b.scholarFirstName.toLowerCase()) {
        return -1
      }
      if (a.scholarFirstName.toLowerCase() > b.scholarFirstName.toLowerCase()) {
        return 1
      }
      return 0
    })

    this.submittedScholars &&
      this.submittedScholars.forEach((child: any) => {
        const selectedSites: any = []
        if (child && child.programId == programId) {
          child.scholarSiteMapping &&
            child.scholarSiteMapping.forEach((site: any) => {
              selectedSites.push(site.siteId)
            })
        }
        const index = applicationSubmissions.findIndex((el: any) => el.scholarId == child.guid)
        if (index !== -1 && applicationSubmissions[index]) {
          applicationSubmissions[index].siteIds = selectedSites
        }
      })

    const mappedApplications =
      applicationSubmissions.map(
        (application: {
          accountId: number
          applicationGuid: string
          elasticApplicationId: string
          name: string
          programId: number
          scholarId: string
          scholarFirstName: string
          scholarLastName: string
          siteIds: any
          isDocumentSubmitted: boolean
          isFormSubmited: boolean
          elasticSubmissionId: string
        }) => {
          return {
            applicationGuid: application.applicationGuid,
            elasticApplicationId: application.elasticApplicationId,
            name: application.name,
            programId: application.programId,
            accountId: application.accountId,
            scholarId: application.scholarId,
            scholarFirstName: application.scholarFirstName,
            scholarLastName: application.scholarLastName,
            siteIds: application.siteIds,
            isDocumentSubmitted: application.isDocumentSubmitted,
            isFormSubmited: application.isFormSubmited,
            elasticSubmissionId: application.elasticSubmissionId
          }
        }
      ) || []

    applicationStore.updatePartIndex({ submissions: applicationSubmissions, index: APP_CONST.ZERO })
    APP_UTILITIES.setCookie('outStandingItems', JSON.stringify(mappedApplications), 1)
    applicationStore.mutateIsOutstandingItems(true)

    const empty_Site_ids: any = []
    localStorage.setItem('all_selected_sites', JSON.stringify(empty_Site_ids))

    //Redirect to the old application workflow for 2 PT applications and those requiring documents
    if (
      applicationSubmissions[APP_CONST.ZERO] &&
      !applicationSubmissions[APP_CONST.ZERO].isFormSubmited &&
      applicationSubmissions[APP_CONST.ZERO].parts &&
      applicationSubmissions[APP_CONST.ZERO].parts.length > APP_CONST.ONE
    ) {
      this.$router.push(APP_CONST.APP_ROUTES.APPLICATION_FORMS.path)
    } else {
      this.$router.push(APP_CONST.APP_ROUTES.APPLICATION_UPLOAD_DOCUMENTS.path)
    }
  }

  showTooltip(val: string, index: number, event: any) {
    this.tooltipText = val
    this.tooltipIndex = index
    const boundBox = event && event.target && event.target.getBoundingClientRect()
    const coordX = boundBox.left
    const coordY = boundBox.top
    this.styleObj = {
      top: (coordY + 40).toString() + 'px',
      left: coordX.toString() + 'px'
    }
  }

  hideTooltip() {
    this.tooltipText = ''
  }
}
